import { render, staticRenderFns } from "./KPIsTable.vue?vue&type=template&id=632fbf90&scoped=true"
import script from "./KPIsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./KPIsTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./KPIsTable.vue?vue&type=style&index=0&id=632fbf90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632fbf90",
  null
  
)

export default component.exports